/* eslint-disable react/no-danger -- Rich text is sanitized with DOMPurify before rendering. */
import React, { useEffect } from 'react';
import { history, connect } from 'umi';

import { get } from 'lodash';
import DOMPurify from 'dompurify';
import useGCPI18n from '@/hooks/useGCPI18n';
import { formatDate, appUrlJump } from '@/utils/utils';
// import { trackSensors } from '@/utils/sensors';
import Header from '@/components/Header';
import { Clickable } from '@/components';
import styles from './index.less';

const RewardDetailMedal = props => {
  const { myRawardDetail = {}, qryUserRewardDetailDXP, saveMemData } = props;
  const GCPI18n = useGCPI18n();

  useEffect(() => {
    // const initAppStr = window.localStorage.getItem('initApp');
    // const initApp = JSON.parse(initAppStr) || {};
    // const { rewardMemId, promotionId, keyId } = history.location.query;
    const { keyId } = history.location.query;
    // getRewardMemDetail({
    //   mobileNumber:
    //     initApp.phone || initApp.mobile ? (initApp.prefix || '86') + (initApp.phone || initApp.mobile) : null,
    //   userId: initApp.userId || '',
    //   subsId: initApp.subsId || '',
    //   custId: initApp.custId || '',
    //   product,
    //   userDimension,
    //   rewardMemId,
    //   promotionId,
    //   keyId,
    // });
    qryUserRewardDetailDXP({
      keyId,
    }).then(res => {
      if (res && res?.data) {
        saveMemData({
          myRawardDetail: res?.data,
        });
      }
    });
    return () => saveMemData();
  }, []);

  // useEffect(() => {
  //   if (myRawardDetail.keyId) {
  //     // 神策埋点
  //     trackSensors('ViewPrizeDetails', {
  //       prize_id: myRawardDetail.keyId,
  //       prize_name: myRawardDetail?.rewardMemName || myRawardDetail?.rewardName,
  //     });
  //   }
  // }, [myRawardDetail.keyId]);

  const handleUseIt = () => {
    if (myRawardDetail?.appUrl) {
      appUrlJump(
        `${myRawardDetail?.appUrl}?couponId=${myRawardDetail?.couponId}&userCouponId=${myRawardDetail?.couponInstId}`,
      );
    }
  };

  const renderRewardDetail = () => {
    const code = myRawardDetail.prcResPwd;
    const serialNumber = myRawardDetail.prcResSn;
    return (
      <>
        {code && (
          <div>
            <span>{GCPI18n('lb_member_ship_code')}</span>
            <span className={styles.valid} style={{ color: '#0638a8' }}>
              {` ${code}`}
            </span>
          </div>
        )}
        {serialNumber && (
          <div>
            <span>{GCPI18n({ id: 'lb_main_serial_number' })}:</span>
            <span className={styles.valid} style={{ color: '#0638a8' }}>
              {` ${serialNumber}`}
            </span>
          </div>
        )}
      </>
    );
  };

  return (
    <div className={styles.page}>
      <Header title={GCPI18n({ id: 'lb_medal_wall_title_rd' })} />
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.rewardImg}>
            <img src={myRawardDetail.imageUrl} alt="" />
          </div>
          <div className={styles.right}>
            <span className={styles.descirbe}>
              {myRawardDetail?.brief ||
                myRawardDetail?.rewardMemName ||
                myRawardDetail?.rewardName ||
                '-'}
            </span>
            <div className={styles.validityBox}>
              {renderRewardDetail()}
              {['14', '15'].includes(`${myRawardDetail.rewardType || ''}`) &&
                myRawardDetail.validDays && (
                  <span className={styles.valiDate}>
                    {GCPI18n({ id: 'lb_main_validity_period' })}: {get(myRawardDetail, 'validDays')}{' '}
                    {GCPI18n({ id: 'lb_main_validity_days' })}
                  </span>
              )}
              {['1', '8', '9', '14', '15', '23'].includes(`${myRawardDetail.rewardType || ''}`) &&
                myRawardDetail.expDate && (
                  <span className={styles.valiDate}>
                    {GCPI18n({ id: 'lb_main_validity_date' })}:{' '}
                    {formatDate(get(myRawardDetail, 'expDate'), true)}
                  </span>
              )}
            </div>
            {`${myRawardDetail.rewardType}` === '23' && (
              <Clickable className={styles.useIt} onClick={() => handleUseIt()}>
                {GCPI18n({ id: 'lb_mian_use_it' })}
              </Clickable>
            )}
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.details}>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(myRawardDetail.comments || ''),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  qryUserRewardDetailDXP: payload =>
    dispatch({
      type: 'memberShipCenter/qryUserRewardDetailDXP',
      payload,
    }),
  saveMemData: payload =>
    dispatch({
      type: 'memberShipCenter/save',
      payload,
    }),
});

export default connect(
  ({ loading, memberShipCenter, index }) => ({
    myRawardDetail: memberShipCenter.myRawardDetail || {},
    loading: loading.effects['memberShipCenter/qryUserRewardDetailDXP'] || false,
    product: index.product,
    userDimension: index.userDimension,
  }),
  mapDispatchToProps,
)(RewardDetailMedal);
